export const UPDATE_DOCUMENT_SIZE_STORAGE = 'UPDATE_DOCUMENT_SIZE_STORAGE';

const updateDocumentSizeStorage = ({ totalDocumentSize }) => ({
  type: UPDATE_DOCUMENT_SIZE_STORAGE,
  payload: { totalDocumentSize },
  resource: 'documents', // don't forget the reducer name to pointe reducer  !
});

export default updateDocumentSizeStorage;
